import React from 'react';
import { Container, Row } from 'shards-react';

import Errors from '../../../components/Errors';
import GenericSearchBar from '../../../components/common/GenericSearchBar/GenericSearchBar';
import { Provider as LoadingProvider } from '../../../contexts/LoadingContext';
import AccountNameOrIdInput from '../../../components/inputs/AccountNameOrIdInput';
import UserEmailInput from '../../../components/inputs/UserEmailInput';
import UserNamesInput from '../../../components/inputs/UserNamesInput';
import PageTitle from '../../../components/PageTitle';
import Constants from '../../../data/Constants';
import { useUsers } from '../../../hooks/queries/useUsers';
import { useUrlState } from '../../../hooks/useUrlState';
import { positiveIntegerParam, stringParam } from '../../../utils/urlStateParams';
import Table from './Table';

const inputs = [UserEmailInput, UserNamesInput, AccountNameOrIdInput];

const URL_STATE_CONFIG = {
  accountNameOrId: stringParam(),
  page: positiveIntegerParam(),
  userEmail: stringParam(),
  userFirstName: stringParam(),
  userLastName: stringParam()
};

const List = () => {
  const [urlState, setUrlState] = useUrlState(URL_STATE_CONFIG);
  const offset = (urlState.page - 1) * Constants.elementsPerPage;
  const filter = {
    accountNameOrId: urlState.accountNameOrId || undefined,
    userEmail: urlState.userEmail || undefined,
    userFirstName: urlState.userFirstName || undefined,
    userLastName: urlState.userLastName || undefined
  };
  const { users, loading, error } = useUsers(filter, {
    limit: Constants.elementsPerPage,
    offset
  });

  const onSubmit = (newFilter) => {
    setUrlState({
      accountNameOrId: newFilter.accountNameOrId?.trim() || '',
      page: 1,
      userEmail: newFilter.userEmail?.trim() || '',
      userFirstName: newFilter.userFirstName?.trim() || '',
      userLastName: newFilter.userLastName?.trim() || ''
    });
  };

  const handlePageClick = (direction) => {
    const page = urlState.page + direction;
    if (page >= 1) setUrlState({ page });
  };

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Usuarios" />
      </Row>
      <LoadingProvider value={loading}>
        <GenericSearchBar handleSubmit={onSubmit} inputs={inputs} values={urlState} />
        <Errors errors={error ? ['No se pudieron cargar los usuarios.'] : null} />
        <Table
          disableNext={users.length < Constants.elementsPerPage}
          disablePrev={urlState.page === 1}
          onPageClick={handlePageClick}
          users={users}
        />
      </LoadingProvider>
    </Container>
  );
};

export default List;
